(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("billingHistory", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/settings/subscription/BillingHistoryView.html",
            controller: ["subscriptionResource", "$scope", "DTOptionsBuilder", "$translate", "$compile", "$filter", "$state", "currencyService", BillingHistoryCtrl],
            controllerAs: "vm"
        };
        function BillingHistoryCtrl(subscriptionResource, $scope, DTOptionsBuilder, $translate, $compile, $filter, $state, currencyService) {
            var vm = this;
            vm.dtInstance = {};
            vm.lang = $translate.proposedLanguage() || $translate.use();
            vm.model = [];
            vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
                return subscriptionResource.getBillingHistory().$promise;
            })
                .withOption("createdRow", function (row, data) {
                // Recompiling so we can bind Angular directive to the DT
                $compile(angular.element(row).contents())($scope);
                row.id = data.paymentId;
            })
                .withOption("headerCallback", function (header) {
                if (!vm.headerCompiled) {
                    // Use this headerCompiled field to only compile header once
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            })
                .withLanguageSource("/app/i18n/datatables/" + vm.lang + ".json")
                .withOption("processing", true)
                .withOption("responsive", { details: { type: "column" } })
                .withOption("order", [1, "desc"])
                .withPaginationType("full_numbers")
                .withOption("rowCallback", rowCallback)
                .withBootstrap();
            vm.dtColumns = [
                { "data": null, "defaultContent": "", "class": "control", "orderable": false, "targets": 0 },
                {
                    "data": "paymentId",
                    "class": "text-nowrap",
                    "render": function (data) {
                        return data;
                    },
                    "title": $translate.instant("common.lists.invoiceNumber")
                },
                {
                    "data": "invoiceDate",
                    "class": "text-nowrap",
                    "render": function (data) {
                        return data != null ? $filter("date")($filter("localFromUtc")(data), "mediumDate") : "";
                    },
                    "title": $translate.instant("common.lists.invoiceDate")
                },
                {
                    "data": "paymentStatus",
                    "class": "text-center",
                    "render": function (data) {
                        return $translate.instant("common.paymentStatus." + data);
                    },
                    "title": $translate.instant("common.lists.paymentStatus")
                },
                {
                    "data": "paidDate",
                    "class": "text-nowrap",
                    "render": function (data) {
                        return data != null ? $filter("date")($filter("localFromUtc")(data), "mediumDate") : "";
                    },
                    "title": $translate.instant("common.lists.paidDate")
                },
                {
                    "data": "total",
                    "render": function (data, type, full) {
                        return $filter("currency")(full.total, currencyService.find(full.currencySymbol).symbol);
                    },
                    "title": $translate.instant("common.lists.total"),
                    "class": "text-right",
                    "orderable": false
                },
                {
                    "data": "amount",
                    "render": function (data, type, full) {
                        return $filter("currency")(full.amount, currencyService.find(full.currencySymbol).symbol);
                    },
                    "title": $translate.instant("common.lists.amountPaid"),
                    "class": "text-right",
                    "orderable": false
                }
            ];
            vm.dtInstanceCallback = function (instance) {
                vm.dtInstance = instance;
            };
            vm.search = function () {
                vm.dtInstance.DataTable.search(vm.dtSearch).draw();
            };
            vm.rowClickHandler = function (paymentId) {
                $state.go("main.settings.subscriptionInvoiceDetails", { invoiceId: paymentId });
            };
            function rowCallback(nRow) {
                // Unbind first in order to avoid any duplicate handler (see https://github.com/l-lin/angular-datatables/issues/87)
                $("td:not(.control)", nRow).unbind("click");
                $("td:not(.control)", nRow).bind("click", function () {
                    vm.rowClickHandler(nRow.id);
                });
                return nRow;
            }
        }
    });
}());
